import validate from "/usr/src/app/content/n3-spas-30008f57-96af-4633-9c5f-67d74c863155/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-30008f57-96af-4633-9c5f-67d74c863155/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}